import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { AdminGuard } from "src/app/guards/admin.guard"
import { AuthGuard } from "src/app/guards/auth.guard"
import { PagesComponent } from "./pages.component"
import { ServicesMenuComponent } from "./services-menu/services-menu.component"
import { CatalogFtthComponent } from "./catalog/catalog-ftth/catalog-ftth.component"
import { CatalogP2pComponent } from "./catalog/catalog-p2p/catalog-p2p.component"
import { CatalogTransportComponent } from "./catalog/catalog-transport/catalog-transport.component"
import { SignupMainComponent } from "./signup-main/signup-main.component"
import { ContactComponent } from "./contact/contact.component"
import { MaintenanceComponent } from "./maintenance/maintenance.component"
import { DownloadAreaComponent } from "./download-area/download-area.component"
import { NotificationAreaComponent } from "./notification-area/notification-area.component"
import { ErrorReportComponent } from "./error-report/error-report.component"
import { NetworkCoverageComponent } from "./network-coverage/network-coverage.component"
import { PointToPointComponent } from "./point-to-point/point-to-point.component"
import { SsoHandlerComponent } from "../shared/sso-handler/sso-handler.component"

const routes: Routes = [
	{
		path: "",
		component: PagesComponent,
		children: [
			{
				path: "",
				redirectTo: "home",
				pathMatch: "full"
			},
			{
				path: "marketing",
				redirectTo: "home",
				pathMatch: "full"
			},
			{
				path: "login",
				component: NetworkCoverageComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "maintenance",
				component: MaintenanceComponent
			},
			{
				path: "sign_up",
				component: SignupMainComponent,
				canActivate: [AuthGuard, AdminGuard]
			},
			{
				path: "report-error",
				component: ErrorReportComponent
			},
			{
				path: "p2p",
				component: PointToPointComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "home",
				component: NetworkCoverageComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "pon",
				component: CatalogFtthComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "p2p-access",
				component: CatalogP2pComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "transport-infrastructure",
				component: CatalogTransportComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "services-menu",
				component: ServicesMenuComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "contact",
				component: ContactComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "download-area",
				component: DownloadAreaComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "notification-area",
				component: NotificationAreaComponent,
				canActivate: [AuthGuard]
			}
		]
	},
	{
		path: "error",
		component: SsoHandlerComponent
	}
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PagesRoutingModule {}
